// extracted by mini-css-extract-plugin
export default {"root":"App-root"};